import {
  colors,
  size,
  mediaQueries,
  Button as RawButton,
  typography,
} from '@everlywell/leaves';
import { SectionTitle as RawSectionTitle } from 'components/SectionTitle';
import styled from 'styled-components';

const SectionTitle = styled(RawSectionTitle)`
  ${typography.overlineText}
  text-align: center;
  padding-bottom: ${size.md}px;
  color: #bfdce0;
  margin: 0;
  font-weight: ${typography.weight.regular};
  line-height: ${size.lg}px;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-bottom: ${size.xl1}px;
  }
`;

const SectionHeadline = styled.h2`
  ${typography.h1Text}
  font-weight: ${typography.weight.regular};
  padding-bottom: ${size.xl1}px;
  color: #c6dfdf;
  font-size: 37px;
  line-height: 44px;
  letter-spacing: -0.6px;
`;

const Button = styled(RawButton)<{ $marginBottom?: string }>`
  margin-bottom: ${(props) => props.$marginBottom};
  font-size: 18px;
  line-height: ${size.lg}px;
  letter-spacing: 0.3px;
  font-weight: ${typography.weight.book};
  padding: 17px ${size.xl3}px;
  margin-bottom: ${size.xs1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${({ $marginBottom }) => $marginBottom || 72}px;
  }
`;

const Reference = styled.p`
  font-size: ${size.sm}px;
  line-height: ${size.lg}px;
  color: ${colors.white};
  margin-top: 18px;
  width: 100%;
`;

export { SectionHeadline, SectionTitle, Button, Reference };
